import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import type { CalendarEvent, CalendarMode, RenderEvent, Timezones } from '../../types';
import styles from './all-day-events.module.css';
import { DayEvents } from './day-events';
import { WeekEvents } from './week-events';

type Properties<T extends CalendarEvent> = {
  allDayRowHeightPx: number;
  days: Date[];
  events: T[];
  mode: CalendarMode;
  renderEvent?: RenderEvent<T>;
  scrollbarWidth: number;
  timezones: Timezones;
};

const AlldayEvents = <T extends CalendarEvent>({
  allDayRowHeightPx,
  days,
  events,
  mode,
  renderEvent,
  scrollbarWidth,
  timezones,
}: Properties<T>) => {
  const { t } = useTranslation(['translationReactComponents']);

  if (events.length === 0 || allDayRowHeightPx === 0) {
    return null;
  }

  return (
    <div
      className={styles['all-day-events']}
      style={{ height: allDayRowHeightPx, paddingRight: `${scrollbarWidth}px` }}
    >
      {timezones.map((tz) => (
        <div className={styles['time-col']} key={tz}>
          <span className={styles['all-day-text']}>{t('All day')}</span>
        </div>
      ))}
      <div className={cn({ [styles['week-grid'] ?? '']: mode === 'week' }, styles['all-day-event'])}>
        {mode === 'week' ? (
          <WeekEvents<T> days={days} events={events} renderEvent={renderEvent} />
        ) : (
          <DayEvents<T> days={days} events={events} renderEvent={renderEvent} />
        )}
      </div>
    </div>
  );
};

export default AlldayEvents;
